// extracted by mini-css-extract-plugin
export default {"link":"NM-z","disabled":"OM-z"};